module.exports = __webpack_public_path__ + "img/sharecopydisable.572b9c56.svg";